<!-- CRMSP-7485 - Empleados VO-->
<section class="extern-vo">
  <div *ngIf="spinner" class="loading-overlay">
    <div class="spinner-border text-light" role="status"></div>
  </div>

  <div class="content">
    <section class="content--item">
      <header class="page-heading">
        <h1 class="content--title">{{ 'externalVoEmployees' | i18next }}</h1>
      </header>

      <section class="employee-section">
        <div class="section-heading">
          <h2>{{ 'externalVoPendingUsers' | i18next }}</h2>
          <span class="count-badge">{{ pendingEmployees.length }}</span>
        </div>

        <div class="table-wrapper" *ngIf="pendingEmployees.length > 0; else noPendingEmployees">
          <table class="custom-table">
            <thead>
              <tr>
                <!--<th>{{ 'externalVoId' | i18next }}</th>-->
                <th>{{ 'name' | i18next }}</th>
                <th>{{ 'nif' | i18next }}</th>
                <th>{{ 'email' | i18next }}</th>
                <th>{{ 'creationDate' | i18next }}</th>
                <th class="text-center">{{ 'requestListActions' | i18next }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let employee of paginatedPendingEmployees; trackBy: trackById">
                <!--<td class="id-cell">{{ employee.id }}</td>-->
                <td>{{ employee.name }}</td>
                <td>{{ employee.dni }}</td>
                <td>{{ employee.email }}</td>
                <td>{{ employee.createdDate | date: 'dd/MM/yyyy' }}</td>
                <td class="text-center actions-cell">
                  <button type="button" class="btn action-btn action-btn--approve" (click)="approve(employee)">
                    {{ 'approve' | i18next | uppercase }}
                  </button>
                  <button type="button" class="btn action-btn action-btn--reject" (click)="reject(employee)">
                    {{ 'reject' | i18next | uppercase }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <mat-paginator
          *ngIf="pendingEmployees.length > pageSize"
          [length]="pendingEmployees.length"
          [pageSize]="pageSize"
          [pageSizeOptions]="[]"
          [hidePageSize]="true"
          [showFirstLastButtons]="true"
          (page)="changePendingPage($event)"
          aria-label="Paginación de usuarios pendientes"
        ></mat-paginator>

        <ng-template #noPendingEmployees>
          <div class="empty-state">{{ 'noData' | i18next }}</div>
        </ng-template>
      </section>

      <section class="employee-section">
        <div class="section-heading">
          <h2>{{ 'externalVoActiveUsers' | i18next }}</h2>
          <span class="count-badge">{{ activeEmployees.length }}</span>
        </div>

        <div class="table-wrapper" *ngIf="activeEmployees.length > 0; else noActiveEmployees">
          <table class="custom-table">
            <thead>
              <tr>
                <!--<th>{{ 'externalVoId' | i18next }}</th>-->
                <th>{{ 'name' | i18next }}</th>
                <th>{{ 'nif' | i18next }}</th>
                <th>{{ 'email' | i18next }}</th>
                <th>{{ 'approvalDate' | i18next }}</th>
                <th class="text-center">{{ 'requestListActions' | i18next }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let employee of paginatedActiveEmployees; trackBy: trackById">
                <!--<td class="id-cell">{{ employee.id }}</td>-->
                <td>{{ employee.name }}</td>
                <td>{{ employee.dni }}</td>
                <td>{{ employee.email }}</td>
                <td>{{ employee.approvalDate | date: 'dd/MM/yyyy' }}</td>
                <td class="text-center actions-cell">
                  <button type="button" class="btn action-btn action-btn--deactivate" (click)="deactivate(employee)">
                    {{ 'deactivate' | i18next | uppercase }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <mat-paginator
          *ngIf="activeEmployees.length > pageSize"
          [length]="activeEmployees.length"
          [pageSize]="pageSize"
          [pageSizeOptions]="[]"
          [hidePageSize]="true"
          [showFirstLastButtons]="true"
          (page)="changeActivePage($event)"
          aria-label="Paginación de usuarios activos"
        ></mat-paginator>

        <ng-template #noActiveEmployees>
          <div class="empty-state">{{ 'noData' | i18next }}</div>
        </ng-template>
      </section>
    </section>
  </div>
</section>
